import { AirlineReviewsList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

export function Reviews() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Discover in-depth airline reviews on First-Class.com. Gain valuable insights into premium travel experiences, services, and passenger satisfaction'
          }
        />
        <title>Airline Reviews and Ratings</title>
      </Head>
      <AirlineReviewsList />
    </>
  );
}

export default withLayout(Reviews, true);
